import { render, staticRenderFns } from "./BbCourseOverview.vue?vue&type=template&id=2c5ef02c"
import script from "./BbCourseOverview.vue?vue&type=script&lang=js"
export * from "./BbCourseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports